import globalState from '@/lib/globalState';

/**
 * GDPR applies per-site and is baked into globalState at build time (siteConfig.GDPRCountry). It never changes per-page, so reading the static value is sufficient and avoids depending on the request-time Silverstripe context.
 */
export const getIsGdprRegion = (): boolean => Boolean(globalState?.siteConfig?.GDPRCountry);
